import React from 'react';

import { Tooltip } from '@/components/Tooltip';

export interface QueryOrderProps {
  value: boolean | undefined;
  editable: boolean;
  onChange: (value: boolean) => void;
}

export function QueryOrder({ value, editable, onChange }: QueryOrderProps) {
  const tooltipContent = 'Controls the sort direction for table results';
  const isDescending = value ?? false;

  if (editable) {
    return (
      <div className="flex items-center gap-2">
        <Tooltip title={tooltipContent}>
          <label
            htmlFor="query-order"
            className="text-chariot-text-secondary text-sm"
          >
            Order:
          </label>
        </Tooltip>
        <select
          id="query-order"
          value={isDescending ? 'desc' : 'asc'}
          onChange={e => onChange(e.target.value === 'desc')}
          className="bg-chariot-background-secondary text-chariot-text-primary border-chariot-stroke focus:border-chariot-brand-primary w-32 rounded-md border px-2 py-1 text-sm outline-none"
          data-testid="query-header-order-input"
        >
          <option value="desc">Descending</option>
          <option value="asc">Ascending</option>
        </select>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2">
      <Tooltip title={tooltipContent}>
        <span className="text-chariot-text-secondary text-sm">Order:</span>
      </Tooltip>
      <span className="text-chariot-text-primary text-sm">
        {isDescending ? 'Descending' : 'Ascending'}
      </span>
    </div>
  );
}
